import { Box, Center, Spinner, Text, VStack, Image, keyframes, ButtonGroup, Button } from '@chakra-ui/react';
import Boneca from '../../images/modalPsicologo.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from 'api/api';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
function TelemedicinaLoadingPagamento() {
  const state = useLocation();
  const { item } = state.state;
  const tipo_credito = item[0].tipo;
  const [atualizar, setAtualizar] = useState(false);
  const navigate = useNavigate();

  async function validaAdesao() {
    await api(`${ENDPOINT}/cache/credito`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        return res.json();
      })
      .then(async (resposta) => {
        if (resposta === true || resposta === 'true') {
          if (tipo_credito === 'clinico') {
            navigate('/aviso-pre-atendimento/', {
              state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false },
            });
            return;
          }

          if (tipo_credito === 'pediatra') {
            navigate('/aviso-pre-atendimento/', {
              state: {
                titulo: 'Pronto Atendimento Pediátrico',
                tela: '/medico-agora/',
                pediatra: true,
              },
            });
            return;
          }

          if (tipo_credito === 'veterinario') {
            navigate('/aviso-pre-atendimento/', {
              state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
            });
          }
        }
      });
  }

  useEffect(() => {
    validaAdesao();
    const timeout = setInterval(() => {
      validaAdesao();
    }, 30 * 1000);
    return () => {
      if (timeout) clearInterval(timeout);
    };
  }, [setAtualizar]);

  return (
    <Center minH="100vh" bgGradient="linear(to-br, #E0F7FA, #B2EBF2)">
      <VStack spacing={8} p={8} borderRadius="2xl" boxShadow="2xl" bg="white" maxW="sm" w="100%">
        <Image src={Boneca} alt="Pagamento" boxSize="120px" mb={2} />
        <Box position="relative" display="flex" alignItems="center" justifyContent="center">
          <Spinner
            thickness="6px"
            speed="0.8s"
            emptyColor="#B2EBF2"
            color="#3FA19C"
            size="xl"
            boxSize="70px"
            style={{ animation: `${spin} 1.2s linear infinite` }}
          />
        </Box>
        <Text fontSize="2xl" fontWeight="bold" color="#3FA19C" textAlign="center">
          Processando pagamento...
        </Text>
        <Text fontSize="md" color="gray.600" textAlign="center">
          Aguarde um instante enquanto confirmamos seu pagamento.
          <br />
          Você será redirecionado automaticamente para a próxima etapa assim que o pagamento for aprovado.
        </Text>
      </VStack>
    </Center>
  );
}

export default TelemedicinaLoadingPagamento;
